import reducer from "./reducer";
export { default as AssetsDiscountsEntryByAPI } from "./components/index";
export { default as assetsDiscountsEntryByAPIReducerName } from "./constants";
export default reducer;
